import { Flex } from '@aloft/toolkit-sui';

import { Typography } from '../../../summary/components/Typography.tsx';

export const CostBreakdownRow = ({
  title,
  value,
  formula,
}: {
  title: string;
  value: string;
  formula: string;
}) => {
  return (
    <Flex flexDirection="column" gap={1}>
      <Flex gap={2}>
        <Typography variant="h4">{title}</Typography>
        <Typography variant="body1">{value}</Typography>
      </Flex>
      <Typography variant="subtitle3">{formula}</Typography>
    </Flex>
  );
};
